<template>
  <div>
    <dashboard></dashboard>
  </div>
</template>

<script>
// import Component from "../component_location"
import Dashboard from '@/views/Dashboard.vue'

export default {
  components: {Dashboard},

  props: [],

  data() {
    return {
    };
  },

  watch: {},

  methods: {
  },

  computed: {},


  mounted() {},
};
</script>

<style></style>
